module.exports = __webpack_public_path__ + "images/leistungen/saubere_filme_leistungen_video_konzeption_mobile.jpg";